export default "__VITE_ASSET__CsQ8E3pl__"